import React from "react";
import PublicHeader from "./PublicHeader";
export default function PartnerHeader({ audience }) { return <PublicHeader audience={audience === "author" ? "author" : "group"} />; }
